import React from 'react';
import { useWorldStore } from '../state/worldStore';
import { SPOR1_CAR } from '../worldRide';
import { useRideGate } from '../hooks/useRideGate';

// Spor1's Lotus — THE CITY'S OWN PARKED ELISE, not a planted prop.
//
// (History, 2026-08-02: a second Elise was mounted for the pickup and Khari
// caught it twice — first huge, then redundant: "there's already a lotus…
// no need to plant a second one." The city model ships with the parked car
// baked in, and CityModel already publishes its world position as the
// store's `landmark` — the fly-in has landed beside it since before this
// feature existed. So the game binds to THAT car.)
//
// This component is now only the BEACON: a warm pool of light on the native
// car while the ride step is open, so Lyra's "yellow Lotus, you can't miss
// it" stays literally true at night. RideOverlay gates the pickup prompt on
// proximity to the same spot.

export default function Spor1Lotus() {
  const entered = useWorldStore((s) => s.entered);
  const interior = useWorldStore((s) => s.interior);
  const ride = useWorldStore((s) => s.ride);
  const landmark = useWorldStore((s) => s.landmark);

  // The beacon is part of the story, so it waits for the story to start —
  // see useRideGate. It used to light for members the moment the ride quest
  // was available, which for a seeded artist is before Lyra has rung.
  const { rideOpen } = useRideGate();
  if (!entered || interior || ride || !rideOpen) return null;

  const [x, , z] = landmark || [SPOR1_CAR.pos[0], 0, SPOR1_CAR.pos[1]];

  return (
    <group position={[x, 0, z]}>
      <pointLight position={[0, 1.2, 0]} intensity={2.2} distance={7} color="#ffd24a" />
    </group>
  );
}
